import { Tag, type TagTone } from "@/components/deck";
import type { LicenseStatus } from "@/lib/api";

/**
 * License status, mapped onto the deck's three tones.
 *
 *   active     → CLEARED  the thing is doing its job
 *   suspended  → MARKER   somebody needs to look at this — the pen mark, which
 *                         is what the same colour means everywhere else in the
 *                         product, rather than a fourth hue invented here
 *   revoked    → HOLD     failure, and terminal
 *
 * Keeping the mapping in one exported object rather than inline means the
 * tests can assert the pairing, which is the part that would rot silently: a
 * suspended license rendered in the same tone as an active one is a support
 * mistake waiting to happen, and it looks fine in a screenshot.
 */
export const STATUS_TONE: Readonly<Record<LicenseStatus, TagTone>> = {
  active: "cleared",
  suspended: "marker",
  revoked: "hold",
};

export function StatusChip({ status, className }: { status: LicenseStatus; className?: string }) {
  return (
    <Tag tone={STATUS_TONE[status]} className={className}>
      {status}
    </Tag>
  );
}
